// extracted by mini-css-extract-plugin
export default {"container":"DescriptionA_container__UZ-YY","title":"DescriptionA_title__LAa0E","text":"DescriptionA_text__qCozr","profit":"DescriptionA_profit__lbmGd"};